import { FC } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Tab, Tabs } from '@mui/material';
import SearchInput from 'src/components/Items/input/SearchInput';
import SPButtons from './SPButtons';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import './styles.scss';

const filterData = ['hosts', 'locations', 'pickup details', 'oneways', 'season price', 'sub price'];

interface IProps {
  tab: number;
  setTab: (tab: number) => void;
  openDelArray: boolean;
  setOpenDelArray: (openDelArray: boolean) => void;
  arrayForDelete: number[];
  setArrayForDelete: (ArrayForDelete: number[]) => void;
  setOpenModal: (open: boolean) => void;
  setSearchByLocation: (search: string) => void;
  handleChangeModal: (isOpen: boolean) => void;
}

const AdminFilter: FC<IProps> = ({
  tab,
  openDelArray,
  arrayForDelete,
  setTab,
  setOpenDelArray,
  setArrayForDelete,
  setOpenModal,
  setSearchByLocation,
  handleChangeModal
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { role } = useTypedSelector(state => state.auth);

  const handleOpenModal = () => {
    if (arrayForDelete.length) setOpenModal(true);
    else {
      enqueueSnackbar(`Please select ${tab === 2 ? 'pickup details' : 'season prices'}`, {
        variant: 'error'
      });
    }
  };

  const handleCloseDelAll = () => {
    setOpenDelArray(false);
    setArrayForDelete([]);
  };

  return (
    <div className='order-table__filter'>
      {role === 'admin' ? (
        <Tabs
          selectionFollowsFocus
          onChange={(e, v) => setTab(v)}
          value={tab}
          indicatorColor='secondary'
        >
          {filterData.map((name, i) => (
            <Tab label={name} key={i} />
          ))}
        </Tabs>
      ) : (
        <h3 className='admin-filter__title'>pickup details</h3>
      )}
      <div className='action-block admin-filter__actions'>
        {tab === 5 && <SearchInput setSearch={setSearchByLocation} placeholder='Enter location' />}
        {(tab === 2 || tab === 4) && (
          <SPButtons
            type={tab === 2 ? 'pickup details' : 'season prices'}
            openDelArray={openDelArray}
            setOpenDelArray={setOpenDelArray}
            handleOpenModal={handleOpenModal}
            handleCloseDelAll={handleCloseDelAll}
          />
        )}
        <Button variant='contained' onClick={() => handleChangeModal(true)}>
          Add {tab === 0 || tab === 1 ? filterData[tab].slice(0, -1) : filterData[tab]}
        </Button>
      </div>
    </div>
  );
};
export default AdminFilter;
